module.exports = __webpack_public_path__ + "img/app_customers_say_02.ed7e2195.jpg";